<template>
   <v-layout  column fill-height>         
    <v-progress-linear v-if="missionGlobalLoading" indeterminate class="my-0"></v-progress-linear>                
    <div class="!grow-0 flex flex-wrap items-center elevation-5" style="z-index: 1;" >
      <div  class="flex-grow-0" style="border:1px solid #ccc;border-bottom: 0px;border-top: 0px;border-left:0px ;">        
        <v-btn v-if="!allSimulationVisibility" class="mx-0" icon @click.prevent="$store.myActions.UI_SHOW_ALL_SIMULATION_MISSION_MAP('map_global');" :title="$t('Pilot.MissionDrawer.ShowAllListedMissionTooltip')" ><v-icon>mdi-eye-off</v-icon></v-btn>  
        <v-btn v-if="allSimulationVisibility" class="mx-0" icon @click.prevent="$store.myActions.UI_HIDE_ALL_SIMULATION_MISSION_MAP('map_global');" :title="$t('Pilot.MissionDrawer.HideAllListedMissionTooltip')" ><v-icon>mdi-eye</v-icon></v-btn>  
      </div>
      <!-- <mission-operator-filter/> -->
      <v-btn class="mr-auto grow-0" :input-value="$store.myGetters.smartPlanningUiState.filterPanelVisible" icon @click.stop.prevent="$store.myGetters.smartPlanningUiState.filterPanelVisible = !$store.myGetters.smartPlanningUiState.filterPanelVisible" :title="$t('Admin.FilterTooltip')" >
        <v-badge color="#dd0000" >
          <template v-slot:badge v-if="hasFilter"> 
            <v-menu open-on-hover >
              <span slot="activator">{{nbFiltre}}</span>
              <v-list>
                <v-list-tile>
                  <v-btn @click="$store.myActions.UI_RESET_SMARTPLANNING_FILTER()">{{$t('Admin.ResetFilterTooltip')}}<v-icon right>mdi-filter-remove</v-icon></v-btn>
                </v-list-tile>
              </v-list>
            </v-menu>
          </template>
          <v-icon>mdi-filter</v-icon>
        </v-badge>                
      </v-btn>               
      <!-- BLF037 : pas de création sans type autorisé dans l'enseigne cible (RG-ACC-052) -->
      <v-btn v-if="$store.myGetters.creationMissionGlobalTypes.length > 0" class="bg-primary !text-white" @click.prevent="addMissionGlobal">{{$t('Simulation.Add')}}<v-icon right>mdi-plus</v-icon></v-btn>      
    </div>    
    <div class="!grow-0 flex flex-col flex-wrap py-2" style="background-color: #eee;" v-if="$store.myGetters.smartPlanningUiState.filterPanelVisible">                    
      <PlanningFilter />
    </div>    
    <div  v-if="missionGlobalLoading" class="flex grow justify-center items-center gap-4" style="font-size: 30px;">
         {{$t('Pilot.MissionDrawer.Loading')}}        
    </div>
    <div v-else class="grow flex" style="position:relative" >              
        <div ref="liste" class="drawer-container flex flex-col " :style="{overflow:missionGlobals.length <= 24?'auto':'none'}" v-if="missionGlobals.length > 0">
          <!-- Zone liste de résultats -->                  
          <auto-virtual-scroll-list        
               v-if="missionGlobals.length > 24"  
              v-resize="onResize" :totalHeight="height"
              :defaultHeight="36"
              :extra-items="5"
              style="width: 100%;">                   
                <MainSimulationLine  v-for="simulation in simulations"  :key="simulation.simulation.MIG_ID" :simulation="simulation" />                                                                    
            </auto-virtual-scroll-list>
            <div v-else >
              <MainSimulationLine  v-for="simulation in simulations"  :key="simulation.simulation.MIG_ID" :simulation="simulation" />                                                                    
            </div>
        </div>    
        <div v-else class="flex items-center justify-center !grow">          
          {{$t('Simulation.NoSimulation')}} 
        </div>
    </div>  
    <v-dialog
        v-model="showEditMissionGlobal"        
        persistent
        close
        scrollable            
        :width="700">
        <v-card  >
          <v-card-text>
            <SimulationNew v-if="showEditMissionGlobal"/>             
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn small @click="showEditMissionGlobal = false" >Close</v-btn>          
            <v-btn small @click="saveMissionGlobal()" color="primary" >Save <v-icon class="ml-2" small>mdi-content-save</v-icon></v-btn>          
        </v-card-actions>
        </v-card>
    </v-dialog> 
  </v-layout> 
</template>
<script lang="ts">

import MissionOperatorFilter from '@/components/mission/MissionOperatorFilter.vue'
import SimulationNew from '@/components/smart/SimulationNew.vue'
import PlanningFilter from '@/components/smart/PlanningFilter.vue'
import MainSimulationLine from '@/components/smart/MainSimulationLine.vue'


import { AloDbMissionGlobal, isAloDbMissionGlobalSimulator } from '@/models/alodb/AloDbMissionGlobal'

import Vue from 'vue'
import Component from 'vue-class-component'
  
@Component({
 name: 'PlanningDrawerInformation',
 components:{MissionOperatorFilter,PlanningFilter,SimulationNew,MainSimulationLine}
})
export default class PlanningDrawerInformation extends Vue {      
  
    
  missionGlobalLoading = true
  showEditMissionGlobal = false  
  missionDetailLoading = -1
  missionRunning = -1  

  get smartPlanningUiState()
  {
    return this.$store.myGetters.smartPlanningUiState
  }

  get uistatebyuiid(){
    return this.$store.myGetters.uistatebyuiid
  }

  get allSimulationVisibility(){
    return this.$store.myGetters.allSimulationVisibility
  }

  get simulationMapVisibility(){
    return this.$store.myGetters.simulationMapVisibility
  }

  height = 100

  async addMissionGlobal() {    
    await this.$store.myActions.MISSIONGLOBAL_SELECT_DETAIL(-1);
    this.showEditMissionGlobal = true
  }

  async saveMissionGlobal() {
    const result = await this.$store.myActions.MISSIONGLOBAL_SAVE_REQUEST() as AloDbMissionGlobal
    this.showEditMissionGlobal = false    
    if((result?.id ??0) > 0)
    {
      this.$router.push({name:'SmartPlanningDetail',params:{simulationid:result.id!.toString()}})      
    }
  }

  get filter() {    
    //@ts-ignore
    return this.$store.myGetters.smartPlanningUiState
  }

  get nbFiltre():number {
    return ((this.filter.filterMission?.length ?? 0) > 0?1:0)
      + ((this.filter.filterTypePlanif?.length ?? 0) > 0?1:0)
      + ((this.filter.filterDateStart?.length ?? 0) > 0?1:0)
      + ((this.filter.filterDateEnd?.length ?? 0) > 0?1:0)      
  }

  get hasFilter() {
    return this.nbFiltre > 0
  }
  


  created() {                 
    //TODO Filtrage temporaire à enlever une fois le webservice securisé  
    Promise.all([
      this.$store.myActions.MISSIONVIRTUAL_ENSURE_LIST(),
      this.$store.myActions.COVERAGEITERATION_ENSURE_LIST(),      
      this.$store.myActions.MISSIONGLOBAL_ENSURE_LIST()
    ])
      .finally(()=> this.missionGlobalLoading = false)
  }   

  // BLF037 — scénarios autorisés pour leur enseigne seulement (RG-ACC-050).
  get missionGlobals(){    
    return this.$store.myGetters.smartScenarios.filter((m:AloDbMissionGlobal) => 
              isAloDbMissionGlobalSimulator(m)   &&              
              ((this.smartPlanningUiState.filterMission?.length??0)==0 || (m.MIG_LIBELLE?.toLowerCase()??'').indexOf(this.smartPlanningUiState.filterMission.toLowerCase()) > -1) &&
              //@ts-ignore
              ((this.smartPlanningUiState.filterTypePlanif?.length??0)==0 || (m.config?.processing_mode?.toLowerCase()??'') == this.smartPlanningUiState.filterTypePlanif.toLowerCase()) &&
              //@ts-ignore
              ((this.$store.myGetters.filterMission?.ensIds?.length ?? 0) == 0 ||  m.ENS_ID == this.$store.myGetters.filterMission?.ensIds?.at(0))
        )
  }

  get simulations() {
    return this.missionGlobals.map(m => {      
      const maxVimId = Math.max(...m.misIdArray,-1)
      return {
        simulation:m,
        misVirtual: m.config?.templateSimId?(this.$store.myGetters.missionVirtualsById[m.config?.templateSimId]??null):(this.$store.myGetters.missionVirtualsById[maxVimId]??null)
      }
    }).filter(m => 
                ((this.smartPlanningUiState.filterDateStart?.length??0)==0 || (m?.misVirtual?.param?.mission_start_date && new Date(m.misVirtual.param.mission_start_date) >= new Date(this.smartPlanningUiState.filterDateStart)) ) &&
                ((this.smartPlanningUiState.filterDateEnd?.length??0)==0 || (m?.misVirtual?.param?.mission_start_date && new Date(m.misVirtual.param.mission_start_date) <= new Date(this.smartPlanningUiState.filterDateEnd)) )
            )
  }

  mounted(){
    this.onResize()
  }

  onResize() {
    //@ts-ignore
    if(this.$refs.liste) this.height = this.$refs.liste.clientHeight        
  }
  
}
</script> 

<style scope>  
  .header-list{
    flex: 0 0 auto;
  }
  .filter{
    flex: 0 0 auto;    
    height: min-content;
    background-color: #eee;
  }
 .liste {
    flex: 1 1 auto;
    overflow: hidden;
    height: min-content;
  }  
</style>